import aa from 'search-insights';
import { getAlgoliaIndexNameGlobal } from './search.helpers';

const userToken = {};
if (window.userId && window.userId !== '0') {
    userToken.userToken = window.userId;
}

aa('init', {
    appId: process.env.ALGOLIA_APP_ID,
    apiKey: process.env.ALGOLIA_API_KEY,
    useCookie: true,
    ...userToken,
});

export const analyticsEvents = {
    COMPANY_EVENT_CLICKED: 'Company Event Clicked',
    COMPANY_MEMBER_CLICKED: 'Company Member Clicked',
    COMPANY_PROPERTY_CLICKED: 'Company Property Clicked',
    COMPANY_SERVICE_CLICKED: 'Company Service Clicked',
    COMPANY_SIMILAR_CLICKED: 'Company Similar Clicked',
    COMPANY_SITE_CRITERIA_CLICKED: 'Company Site Criteria Clicked',
    EVENT_ADDED_TO_CART: 'Event Added to Cart',
    FAVORITE_CLICKED: 'Favorite Clicked',
    HIT_CLICKED: 'Hit Clicked',
    HIT_CONVERTED: 'Hit Converted',
    MEMBER_APPOINTMENT_REQUESTED: 'Member Appointment Requested',
    MEMBER_MESSAGE_SENT: 'Member Message Sent',
    PROPERTY_CONTACT_CARD_CLICKED: 'Property Contact Card Clicked',
    PROPERTY_INQUIRY_SENT: 'Property Inquiry Sent',
    PROPERTY_MANAGER_CARD_CLICKED: 'Property Manager Card Clicked',
    PROPERTY_MARKETPLACES_IQ_LINK_CLICKED: 'Property Marketplaces IQ Link Clicked',
    PROPERTY_SITE_PLAN_DOWNLOADED: 'Property Site Plan Downloaded',
    SHARE_BUTTON_CLICKED: 'Share Button Clicked',
};

export const trackConversion = ({ eventName = analyticsEvents.HIT_CONVERTED, index, objectID, queryID }) => {
    if (!index || !objectID) {
        return;
    }

    const indexName = getAlgoliaIndexNameGlobal(index);

    if (queryID) {
        aa('convertedObjectIDsAfterSearch', {
            eventName,
            index: indexName,
            objectIDs: [objectID],
            queryID,
        });

        return;
    }

    aa('convertedObjectIDs', {
        eventName,
        index: indexName,
        objectIDs: [objectID],
    });
};
